<script setup lang="ts">
import {Widget as IWidget} from "@/laboratory/components/dashboard/dashboard";
import {onMounted, ref} from "vue";
import {laboratoryApi} from "@/container";
import BarChartWidget from "@/laboratory/components/dashboard/components/visualizations/BarChartWidget.vue";
import ObjectiveWidget from "@/laboratory/components/dashboard/components/visualizations/ObjectiveWidget.vue";
import SimpleValueWidget from "@/laboratory/components/dashboard/components/visualizations/SimpleValueWidget.vue";
import LineChartWidget from "@/laboratory/components/dashboard/components/visualizations/LineChartWidget.vue";
import BackToBackBarChartWidget
    from "@/laboratory/components/dashboard/components/visualizations/BackToBackBarChartWidget.vue";
import PieChartWidget from "@/laboratory/components/dashboard/components/visualizations/PieChartWidget.vue";
import {Skeleton} from "@/core/components/ui/skeleton";
import {Widget} from "@/laboratory/components/dashboard/components/widget";
import PatientConversionWidget
    from "@/laboratory/components/dashboard/components/visualizations/PatientConversionWidget.vue";
import PeriodComparisonWidget
    from "@/laboratory/components/dashboard/components/visualizations/PeriodComparisonWidget.vue";

const props = defineProps<{
    laboratoryId: string | number;
    widget: IWidget;
}>();

const factory: Record<IWidget["type"], any> = {
    "bar-chart": BarChartWidget,
    "objective": ObjectiveWidget,
    "patient-conversion": PatientConversionWidget,
    "simple-value": SimpleValueWidget,
    "line-chart": LineChartWidget,
    "back-to-back-chart": BackToBackBarChartWidget,
    "pie-chart": PieChartWidget,
    "period-comparison": PeriodComparisonWidget
};

const widgetData = ref<IWidget>();
const isLoading = ref(true);

onMounted(() => {
    laboratoryApi().widget(props.laboratoryId, props.widget.id)
        .then((response) => {
            widgetData.value = response;
            isLoading.value = false;
        })
        .catch((error) => {
            console.error("Error fetching widget data:", error);
            isLoading.value = false;
        });
});

const componentToRender = factory[props.widget.type];
</script>

<template>
  <component :is="componentToRender as any" v-if="widgetData && !isLoading" :widget="widgetData" />
  <Widget v-else :widget="widget">
    <Skeleton class="min-h-96 h-full" />
  </Widget>
</template>

<style scoped>

</style>
